import React from 'react';
import PropTypes from 'prop-types';
import ListTableToolbar from './ListTableToolbar';
import ListTable from './ListTable';
import BreadCrumbs from '../BreadCrumbs';

const ListPage = ({
  onAdd,
  onSearch,
  onRefresh,
  loading,
  data,
  onTableChange,
  pagination,
  columns,
  rowKey,
  breadCrumbItems,
  hideAddAction,
  showStatusFilter,     // 👈 new
  onStatusChange,       // 👈 new
  showHasStatusFilter,
  hasRushFilterChecked = false,
  onhasRushStatusChange
}) => {
  return (
    <>
      <BreadCrumbs items={breadCrumbItems} />
      <div className="row">
        <div className="col-sm-12">
          <div className="card card-table show-entire">
            <div className="card-body">
              {/* Table Header */}
              <ListTableToolbar
                onAdd={onAdd}
                onRefresh={onRefresh}
                onSearch={onSearch}
                hideAddAction={hideAddAction}
                showStatusFilter={showStatusFilter}
                onStatusChange={onStatusChange}
                showHasStatusFilter={showHasStatusFilter}
                hasRushFilterChecked={hasRushFilterChecked}
                onhasRushStatusChange={onhasRushStatusChange}
              />

              {/* /Table Content */}
              <ListTable
                columns={columns}
                data={data}
                loading={loading}
                pagination={pagination}
                onTableChange={onTableChange}
                rowKey={rowKey}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ListPage.propTypes = {
  ...ListTableToolbar.propTypes,
  ...ListTable.propTypes,
  breadCrumbItems: PropTypes.array,
  showStatusFilter: PropTypes.bool,
  onStatusChange: PropTypes.func,
  showHasStatusFilter: PropTypes.bool,
  hasRushFilterChecked: PropTypes.bool,
  onhasRushStatusChange: PropTypes.func,
};

export default ListPage;
